/**
 * Shared pagination defaults for paged API list endpoints. Used by
 * any saga / component that fetches a `limit/offset` (or `limit/before`)
 * page from the BFF — kept in one place so the cadence of
 * "request another batch" stays consistent across features.
 */

// Default page size for client-driven list endpoints (background
// tasks, completion log, etc.). The server's hard cap is higher;
// this is a UX cadence choice — a screenful's worth of rows, with
// room to load-more without feeling sparse.
export const DEFAULT_PAGE_SIZE = 25;
